import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const ErrorIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99989 0.00499725C3.58265 0.00499725 0.00488281 3.58276 0.00488281 8C0.00488281 12.4172 3.58265 15.995 7.99989 15.995C12.4171 15.995 15.9949 12.4172 15.9949 8C15.9949 3.58276 12.4171 0.00499725 7.99989 0.00499725ZM7.00051 12.9969V10.9981H8.99926V12.9969H7.00051ZM7.00051 3.00312V9.99875H8.99926V3.00312H7.00051Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default ErrorIcon;
